import React from "react";

const ToS = () => (
  <section className="space-y-3">
    <div className="text-sm">
      I have read and agree to Elektra Health’s{" "}
      <a
        href="https://www.elektrahealth.com/terms-of-use/"
        target="_blank"
        className="text-indigo font-medium underline"
        aria-description="Terms of Use link"
        role="link"
      >
        Terms of Use
        <span className="sr-only"> (opens in a new window)</span>
      </a>{" "}
      and{" "}
      <a
        href="https://www.elektrahealth.com/privacy-policy/"
        target="_blank"
        className="text-indigo font-medium underline"
        aria-description="Privacy Policy link"
        role="link"
      >
        Privacy Policy
        <span className="sr-only"> (opens in a new window)</span>
      </a>
      .
    </div>
    <div className="text-sm">
      I have read and agree to Mighty Networks’{" "}
      <a
        href="https://www.mightynetworks.com/terms-of-use#_gl=1*1iepiiq*_ga*MTkwMTQ5ODQwOC4xNzM5NDY5MjAy*_ga_T49FMYQ9FZ*MTczOTQ2OTIwMS4xLjEuMTczOTQ2OTM4My4wLjAuMA..*_ga_NEGJ2SXNP7*MTczOTQ2OTIwMS4xLjEuMTczOTQ2OTM4My41Ny4wLjA"
        target="_blank"
        className="text-indigo font-medium underline"
        aria-description="Terms of Use link"
        role="link"
      >
        Terms of Use
        <span className="sr-only"> (opens in a new window)</span>
      </a>{" "}
      and{" "}
      <a
        href="https://www.mightynetworks.com/privacy-policy#_gl=1*1iepiiq*_ga*MTkwMTQ5ODQwOC4xNzM5NDY5MjAy*_ga_T49FMYQ9FZ*MTczOTQ2OTIwMS4xLjEuMTczOTQ2OTM4My4wLjAuMA..*_ga_NEGJ2SXNP7*MTczOTQ2OTIwMS4xLjEuMTczOTQ2OTM4My41Ny4wLjA."
        target="_blank"
        className="text-indigo font-medium underline"
        aria-description="Privacy Policy link"
        role="link"
      >
        Privacy Policy
        <span className="sr-only"> (opens in a new window)</span>
      </a>
      .
    </div>
  </section>
);

export default ToS;
